<template>
  <div>
    <div :style="{ display: 'none' }">
      <v-text-field required :rules="rules" :value="check" readonly />
    </div>
    <v-row>
      <v-col :sm="11">
        <div class="caption font-weight-bold">
          {{ label || $t(`table.content`) }}
          <span class="red--text" v-if="rules">
            <strong>*</strong>
          </span>
        </div>
        <div v-if="url">
          <span :class="isCopy ? 'primary white--text' : ''">{{ url }}</span>
          <v-icon
            size="20"
            color="black--text"
            role="button"
            v-clipboard:copy="url"
            v-clipboard:success="_fnOnCopy"
          >
            mdi-content-copy
          </v-icon>
        </div>
      </v-col>
      <v-col :sm="1" class="text-right pt-1 pr-0">
        <v-upload
          v-if="!readonly"
          :size="30"
          v-model="url"
          icon="mdi-cloud-upload"
        />
      </v-col>
    </v-row>
    <ckeditor
      v-model="check"
      :read-only="readonly"
      :config="{ height: height }"
      @input="_fnChange"
    />
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
    rules: Array,
    readonly: Boolean,
    label: String,
    height: {
      type: Number,
      default: 250,
    },
  },
  data() {
    return {
      url: "",
      check: "",
      isCopy: false,
    };
  },
  watch: {
    url: function () {
      this.isCopy = false;
    },
  },
  created() {
    this.check = this.value;
  },
  methods: {
    _fnOnCopy() {
      this.isCopy = true;
    },
    _fnChange() {
      this.$emit("change", this.check);
    },
  },
};
</script>
